module.exports = __webpack_public_path__ + "static/media/image_83.d87a363c.png";